<template>
  <v-flex sm12 md12 lg12>
    <v-snackbar
      ref="snackbar"
      :value="snackbar"
      :color="component.httpStatus == 200 ? 'green' : 'red'"
      :timeout="component.httpStatus == 200 ? 3000 : -1"
      :vertical="false"
    >
      <span class="mt-2 mr-2" style="display: inline-block">{{
        component.message
      }}</span>
      <v-btn
        class="dark lighten-1 float-right pa-0 ma-0"
        style="font-size: 12px"
        dark
        @click="snackbar = false"
        >CLOSE</v-btn
      >
    </v-snackbar>
  </v-flex>
</template>
<script>
export default {
  name: "MessageAlert",
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      snackbar: false,
    };
  },
  computed: {
    submitted: function () {
      if (this.component.httpStatus === 200) {
        return "success";
      } else return "error";
    },
  },
  watch: {
    component: function () {
      if (this.component.httpStatus !== 0) this.snackbar = true;
      else this.snackbar = false;
    },
  },
};
</script>
